{
  "name": "docmeta",
  "version": "4.14.0",
  "description": "Validate the presence and format of document metadata (Markdown frontmatter and more) against JSON Schema. CI-friendly.",
  "type": "module",
  "bin": {
    "docmeta": "dist/cli.js"
  },
  "main": "dist/index.js",
  "module": "dist/index.js",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js"
    },
    "./package.json": "./package.json"
  },
  "files": [
    "dist"
  ],
  "repository": {
    "type": "git",
    "url": "git+https://github.com/hawkeyexl/docmeta.git"
  },
  "homepage": "https://hawkeyexl.github.io/docmeta/",
  "bugs": {
    "url": "https://github.com/hawkeyexl/docmeta/issues"
  },
  "publishConfig": {
    "access": "public"
  },
  "engines": {
    "node": ">=24"
  },
  "scripts": {
    "prebuild": "npm run check:deps",
    "build": "tsup",
    "dev": "tsup --watch",
    "pretest": "npm run check:deps",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "pretypecheck": "npm run check:deps",
    "typecheck": "tsc --noEmit",
    "lint": "eslint .",
    "check:deps": "node scripts/check-deps.mjs",
    "query:ui": "npm run build && node dist/cli.js query --db .docmeta/query.db && node scripts/query-ui.mjs .docmeta/query.db",
    "docs:check-cli": "node scripts/check-cli-reference.mjs",
    "docs:check-action": "node scripts/check-action-reference.mjs",
    "docs:check-api": "node scripts/check-api-reference.mjs",
    "docs:check-links": "node scripts/check-doc-links.mjs",
    "docs:check-tables": "node scripts/check-table-rows.mjs",
    "schemas:sync": "node scripts/sync-builtin-schemas.mjs",
    "schemas:check": "node scripts/check-builtin-schemas.mjs",
    "schemas:check-published": "node scripts/check-published-schemas.mjs",
    "commitlint": "commitlint --edit",
    "semantic-release": "semantic-release",
    "prepare": "node scripts/prepare.mjs",
    "prepublishOnly": "npm run build"
  },
  "keywords": [
    "frontmatter",
    "metadata",
    "json-schema",
    "markdown",
    "validation",
    "cli",
    "ci",
    "okf"
  ],
  "license": "MIT",
  "overrides": {
    "esbuild": "^0.28.2"
  },
  "dependencies": {
    "@hawkeyexl/inference": "^0.3.1",
    "@xmldom/xmldom": "^0.9.12",
    "ajv": "^8.17.1",
    "ajv-draft-04": "^1.0.0",
    "ajv-formats": "^3.0.1",
    "commander": "^15.0.0",
    "fast-glob": "^3.3.2",
    "parse5": "^8.0.1",
    "picocolors": "^1.1.1",
    "picomatch": "^4.0.7",
    "smol-toml": "^1.8.0",
    "yaml": "^2.6.1"
  },
  "devDependencies": {
    "@commitlint/cli": "^21.2.2",
    "@commitlint/config-conventional": "^21.2.2",
    "@eslint/js": "^10.0.1",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/commit-analyzer": "^13.0.1",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/github": "^12.0.8",
    "@semantic-release/npm": "^13.1.5",
    "@semantic-release/release-notes-generator": "^14.1.1",
    "@types/node": "^26.3.0",
    "@types/picomatch": "^4.0.3",
    "@vitest/coverage-v8": "^4.1.11",
    "eslint": "^10.9.1",
    "globals": "^17.11.0",
    "husky": "^9.1.7",
    "semantic-release": "^25.0.9",
    "tsup": "^8.3.5",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.68.0",
    "vitest": "^4.1.11"
  }
}
